import {useAppSelector} from "../../../../../../redux/hooks";
import {musicHomeStore} from "../../../../../songs-router/modules/music-home-store/musicHomeStore";

export interface IMusicHomeSearchControlResetButtonLogic {
  isResetButtonAvailable: boolean,
  handleSearchInputReset: () => void,
}

export const useMusicHomeSearchControlResetButtonLogic = (): IMusicHomeSearchControlResetButtonLogic => {
  const isSearchFocused = useAppSelector(musicHomeStore.isSearchFieldFocused);
  const searchValue = useAppSelector(musicHomeStore.getSearchText);

  const isResetButtonAvailable: boolean = (
    isSearchFocused
    || searchValue.trim().length > 0
  );

  return {
    isResetButtonAvailable,
    handleSearchInputReset: musicHomeStore.resetAndCloseSearch,
  };
}
